export default "__VITE_ASSET__6fKVeHXd__"